import React from "react";
import { useForm } from "react-hook-form";
import welcomImage from "../Assets/welcome.png";
import { Button } from "../Components/Basic";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

export default function Welcome() {
  // this is the for navigation
  const history = useHistory();
  return (
    <div className="h-screen w-4/6 mx-auto">
      <div className="flex">
        <section className=" mt-10 md:mt-2 md:flex-1 self-center	">
          <p className="text-3xl mt-5">Understand Divorce Costs & Process </p>
          <p className="mt-5 text-xl font-bold text-nativeBlue-200">
            Takes Just 3 Minutes
          </p>
          <p className=" mt-5 mb-10 text-base">
            Let’s first find out if you are able to get divorced, then we’ll ask
            you a few questions to understand your circumstances.
          </p>
          <Button
            onClick={() => history.push("/divorce-assessment")}
            fontSize="lg"
            className="w-11/12 md:w-full md:max-w-xs mx-3 md:mx-0 p-4 focus:outline-none bg-nativeOrange-200 hover:bg-yellow-500  hover:border-yellow-500"
          >
            Get Started
          </Button>
        </section>

        <section className="flex-1 md:flex-1 invisible md:visible">
          <img src={welcomImage} alt="Welcome To Divorce Assessment" />
        </section>
      </div>
    </div>
  );
}
